/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DoCheck, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Notification } from './notification';
import { NotificationContext } from './notification-context.service';

/**
 * Panel of notifications displayed in the overlay.
 */
@Component({
  selector: 'gh-notification-panel',
  template: require('./notification-panel.component.html'),
  styles: [require('./notification-panel.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationPanelComponent implements OnInit, OnDestroy, DoCheck {
  items: Notification[];

  private _items: Notification[];
  private subscription: Subscription;

  constructor(private context: NotificationContext,
              private changeDetectorRef: ChangeDetectorRef) {

  }

  ngOnInit(): void {
    this.subscription = this.context.subscribe((items) => {
      // Sometimes Angular throws ExpressionWasChangedAfterItHasBeenCheckedError when notification was thrown
      // on OnInit phase of component.
      // This code guarantees that state of component (state relevant for template) is changed only in right moment:
      // state is ALWAYS changed on DoCheck phase
      this._items = items;
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngDoCheck(): void {
    this.items = this._items;
  }
}
